module.exports = __webpack_public_path__ + "img/icon-music-tab.9067dab8.png";